import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import axios from 'axios';
import CouponUseList from './CouponUseList';

export default function CouponDetail(props) {
  const { open, handleClose, companyId, orderId } = props;
  const [couponQuantity, setCouponQuantity] = useState(0);

  useEffect(async () => {
    if (open) {
      let params = { orderId };
      setCouponQuantity((await axios.get(`/api/coupon/count/${companyId}`, { params })).data.couponQuantity);
    }
  }, [open, couponQuantity]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
      <Box noValidate sx={{ mt: 1, minWidth: 500 }}>
        <DialogTitle id="draggable-dialog-title">사용권 사용 내역</DialogTitle>
        <DialogContent dividers>
          잔여 사용권 : {couponQuantity}
          <CouponUseList companyId={companyId} orderId={orderId} />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="success" onClick={handleClose}>
            닫기
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
